var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gi-box",style:({'backgroundImage': _vm.data ? 'url(' + _vm.data['板块背景'] + ')' : ''})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }